import Vue from 'vue';
import VueRouter from 'vue-router';
import {
  PageNotFound,
} from '@bizfly/shared';
import i18n from '../utils/i18n';

Vue.use(VueRouter);

export const routes = [
  {
    path: '/',
    redirect: { path: '/machines' },
  },
  {
    path: '/',
    name: 'ListLayout',
    component: () => import('@/layout/ListLayout'),
    children: [
      {
        path: 'machines',
        name: 'Machines',
        component: () => import('@/views/machine/index'),
        meta: { title: 'Machine' },
      },
      {
        path: 'policy',
        name: 'Policy',
        component: () => import('@/views/policy/index'),
        meta: { title: 'Policy' },
      },
      {
        path: 'history',
        name: 'History',
        component: () => import('@/views/history/index'),
        meta: { title: i18n.t('shared.history') },
      },
    ],
  },
  {
    path: '/',
    name: 'MachineDetailLayout',
    component: () => import('@/layout/MachineDetailLayout.vue'),
    children: [
      {
        path: 'machine/:machineId/detail',
        name: 'MachineDetail',
        component: () => import('@/views/machine/details/Detail'),
        meta: { title: `${i18n.t('shared.information')} Machine` },
      },
      {
        path: 'machine/:machineId/recovery-point',
        name: 'MachineRecoveryPoint',
        component: () => import('@/views/machine/details/RecoveryPoint'),
        meta: { title: 'Recovery Point' },
      },
      {
        path: 'machine/:machineId/history',
        name: 'MachineHistory',
        component: () => import('@/views/machine/details/History'),
        meta: { title: i18n.t('shared.history') },
      },
      {
        path: 'machine/:machineId/delete',
        name: 'MachineDelete',
        component: () => import('@/views/machine/details/Delete'),
        meta: { title: `${i18n.t('button.delete')} Machine` },
      },
    ],
  },
  {
    path: '/',
    name: 'FolderLayout',
    component: () => import('@/layout/FolderLayout.vue'),
    children: [
      {
        path: 'folder/create',
        name: 'CreateFolder',
        component: () => import('@/views/folder/Config'),
        meta: { title: i18n.t('cloudBackup.listMachine.addNewFolder') },
      },
      {
        path: 'folder/edit',
        name: 'EditFolder',
        component: () => import('@/views/folder/Config'),
        meta: { title: i18n.t('cloudBackup.listMachine.editFolder') },
      },
      {
        path: 'folder/restore',
        name: 'RestoreFolder',
        component: () => import('@/views/folder/Restore'),
        meta: { title: i18n.t('cloudBackup.listMachine.restoreFolder') },
      },
    ],
  },
  {
    path: '/',
    name: 'CreateEditLayout',
    component: () => import('@/layout/CreateEditLayout'),
    children: [
      {
        path: 'machine/create',
        name: 'MachineCreate',
        component: () => import('@/views/machine/Create'),
        meta: { title: `${i18n.t('button.create')} Machine` },
      },
      {
        path: 'policy/create',
        name: 'PolicyCreate',
        component: () => import('@/views/policy/Create'),
        meta: { title: `${i18n.t('button.create')} Policy` },
      },
      {
        path: '/policy/edit',
        name: 'UpdatePolicy',
        component: () => import('@/views/policy/Create'),
        meta: { title: `${i18n.t('button.update')} Policy` },
      },
    ],
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: PageNotFound,
    meta: {
      title: '404',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes,
});

export default router;
